/* Native HTML links, forms and disclosures also work without this enhancement. */
(() => {
  function closeMenus(event) {
    document.querySelectorAll('.tr-header details[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  }
  document.addEventListener('click', closeMenus);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.tr-header details[open]').forEach((menu) => {
      menu.removeAttribute('open');
      menu.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('toggle', (event) => {
    if (!event.target.matches?.('.tr-desktop-nav>details') || !event.target.open) return;
    event.target.parentElement.querySelectorAll('details[open]').forEach((other) => {
      if (other !== event.target) other.removeAttribute('open');
    });
  }, true);
})();
